export default {
  users: 'Usuários',
  'users.domain.name': 'Nome',

  'users.create': 'Criar Novo Usuário',
};
